import React, { useMemo } from 'react'
import { Separator } from '@fs/zion-ui'
import isEqual from 'lodash.isequal'
import ChangeHistoryCard from '../ChangeHistoryCard/ChangeHistoryCard'
import { useGroupData } from '../../../../hooks'
import ChangeHistoryCoverageList from '../../../../components/CoverageList/ChangeHistoryCoverageList'

export default function CoveragesHistory({ onFinish, selectedChanges }) {
  const groupData = useGroupData()

  const currentCoverages = groupData?.group?.coverages
  const selectedCoverages = selectedChanges?.coverages
  const status = useMemo(() => {
    if (selectedCoverages == null || currentCoverages == null) return null
    const statusObj = {}
    const isCoverageEqual = compareCoverages(selectedCoverages, currentCoverages)
    if (isCoverageEqual) statusObj.status = 'CURRENT'
    else if (isEqual(selectedCoverages, [])) statusObj.status = 'REMOVED'
    else statusObj.status = 'RESTORE'
    statusObj.data = { coverages: selectedCoverages }
    return statusObj
  }, [currentCoverages, selectedCoverages])

  return Array.isArray(selectedChanges?.coverages) ? (
    <ChangeHistoryCard onFinish={onFinish} restoreStatus={status} date={selectedChanges?.date?.fromTimestamp}>
      <ChangeHistoryCoverageList coverages={selectedChanges.coverages} smallText />
      <Separator size="xxs" />
    </ChangeHistoryCard>
  ) : null
}

export function compareCoverages(arr1, arr2) {
  // remove apolloid from all items in arrays
  return isEqual(removeApolloId(arr1), removeApolloId(arr2))
}

function removeApolloId(arr) {
  const arrCopy = []
  arr.forEach((coverage) => {
    const typesToCopy = []
    coverage.recordTypes.forEach((type) => {
      const typeToCopy = (({ apolloId, id, ...obj }) => obj)(type)
      typesToCopy.push(typeToCopy)
    })
    arrCopy.push({ ...coverage, recordTypes: typesToCopy })
  })
  return arrCopy
}
